import React from 'react';
import { useCases } from '../mock';
import { Factory, Truck, Wrench } from 'lucide-react';

const iconMap = [
  Factory,
  Truck,
  Wrench
];

const UseCases = () => {
  return (
    <section id="casos" style={{
      backgroundColor: '#000000',
      padding: '100px 7.6923%',
      position: 'relative'
    }}>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <h2 style={{
          fontSize: '48px',
          fontWeight: 600,
          lineHeight: 1.1,
          letterSpacing: '-0.02em',
          color: '#FFFFFF',
          marginBottom: '20px',
          textAlign: 'center'
        }}>
          Casos de Uso
        </h2>
        
        <p style={{
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: 1.5,
          color: 'rgba(255, 255, 255, 0.85)',
          marginBottom: '60px',
          textAlign: 'center',
          maxWidth: '800px',
          margin: '0 auto 60px'
        }}>
          Aplicaciones reales de nuestras tecnologías en entornos industriales
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '40px'
        }}>
          {useCases.map((useCase, index) => {
            const IconComponent = iconMap[index];
            return (
              <div key={useCase.id} style={{
                backgroundColor: '#121212',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                padding: '40px',
                transition: 'all 0.4s ease-in-out',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-4px)';
                e.currentTarget.style.borderColor = '#00FFD1';
                e.currentTarget.style.boxShadow = '0 8px 32px rgba(0, 255, 209, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.25)';
                e.currentTarget.style.boxShadow = 'none';
              }}>
                <div style={{
                  width: '56px',
                  height: '56px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  marginBottom: '24px',
                  color: '#00FFD1'
                }}>
                  <IconComponent size={40} />
                </div>
                
                <h3 style={{
                  fontSize: '24px',
                  fontWeight: 600,
                  lineHeight: 1.3,
                  letterSpacing: '-0.02em',
                  color: '#FFFFFF',
                  marginBottom: '16px'
                }}>
                  {useCase.title}
                </h3>
                
                <p style={{
                  fontSize: '16px',
                  fontWeight: 400,
                  lineHeight: 1.4,
                  color: 'rgba(255, 255, 255, 0.85)'
                }}>
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCases;